import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("w4l_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function apiError(detail) {
  if (detail == null) return "Qualcosa è andato storto.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && e.msg ? e.msg : JSON.stringify(e))).join(" ");
  if (detail.msg) return detail.msg;
  return String(detail);
}

export async function transcribeAudio(blob, lang) {
  const fd = new FormData();
  fd.append("audio", blob, "audio.webm");
  const token = localStorage.getItem("w4l_token");
  const res = await fetch(
    `${process.env.REACT_APP_BACKEND_URL}/api/transcribe?lang=${lang}`,
    { method: "POST", headers: token ? { Authorization: `Bearer ${token}` } : {}, body: fd }
  );
  if (!res.ok) throw new Error("transcribe failed");
  return (await res.json()).text;
}
